import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Conversation {
  id: string;
  title: string;
  last_message?: string;
  updated_at: string;
}

export default function Conversations() {
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadConversations();
  }, []);

  async function loadConversations() {
    try {
      setLoading(true);
      setError('');
      const res = await api.get('/api/conversations');
      setConversations(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Conversations</h1>
      {error && <div style={styles.error}>{error}</div>}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={styles.card}>
          {conversations.length === 0 && <div style={styles.empty}>No conversations</div>}
          {conversations.map((c) => (
            <div key={c.id} style={styles.row}>
              <div>
                <div style={styles.rowTitle}>{c.title}</div>
                <div style={styles.rowMeta}>{c.last_message ?? 'No messages yet'}</div>
              </div>
              <div style={styles.rowDate}>{new Date(c.updated_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  card: { background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb' },
  empty: { padding: 20, color: '#9ca3af' },
  row: { padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between' },
  rowTitle: { fontWeight: 500, fontSize: 14 },
  rowMeta: { fontSize: 12, color: '#6b7280', marginTop: 2 },
  rowDate: { fontSize: 12, color: '#9ca3af' },
};
